import { render } from "./OssUploader.vue?vue&type=template&id=c0f49238"
import script from "./OssUploader.vue?vue&type=script&lang=js"
export * from "./OssUploader.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__